import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-countdown', 'days', 'Päevad');
Labels.set('ui-countdown', 'hours', 'Tunnid');
Labels.set('ui-countdown', 'minutes', 'Minutid');
Labels.set('ui-countdown', 'seconds', 'Sekundid');
